module.exports = __webpack_public_path__ + "static/media/cure-headphones-healthy-life-svgrepo-com.e0e4764c.svg";